import { Autocomplete, TextField } from '@mui/material';
import { WidgetProps } from '@rjsf/utils';
import { SyntheticEvent } from 'react';

const ModelSpecificationGroupAutocompleteWidget = (props: WidgetProps) => {
  const autocompleteOptions = (props.options.autocompleteOptions || []) as string[];

  const handleAutocompleteChange = (_: SyntheticEvent, newValue: string | null) => {
    props.onChange(newValue);
  };

  return (
    <Autocomplete
      freeSolo
      autoSelect
      value={props.value}
      onChange={handleAutocompleteChange}
      options={autocompleteOptions}
      getOptionLabel={(option) => option}
      disabled={props.disabled}
      renderInput={(params) => <TextField {...params} label="Group" />}
      sx={(theme) => ({
        '& .MuiInputBase-root': {
          height: theme.spacing(5.5),
        },
      })}
    />
  );
};

export default ModelSpecificationGroupAutocompleteWidget;
